import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Modal from '../Modal';
import Card from '../Card';
import CardContent from '../CardContent';
import Loader from '../Loader';
import Button from '../Button';

const useStyles = makeStyles({
  content: {
    textAlign: 'center',
  },
  title: {
    fontWeight: 300,
    fontSize: 26,
    marginBottom: 16,
  },
  text: {
    fontWeight: 300,
    fontSize: 16,
    lineHeight: '24px',
    marginBottom: 24,
    color: 'rgba(0,0,0,0.7)',
  },
});

const RedirectingModal = ({
  open,
  url,
  title,
  text,
  buttonLabel,
  delay,
  autoRedirect,
  onLogOut,
}) => {
  const classes = useStyles();

  useEffect(() => {
    if (!open || !url || !autoRedirect) return undefined;

    const timeout = setTimeout(() => {
      window.location.replace(url);
    }, delay);

    return () => clearTimeout(timeout);
  }, [open, url, delay, autoRedirect]);

  return (
    <Modal open={open} handleClose={() => {}} narrow>
      <Card>
        <CardContent className={classes.content}>
          <Typography variant="h1" component="h3" className={classes.title}>
            {title}
          </Typography>

          <Typography variant="body1" className={classes.text}>
            {text}
          </Typography>

          {autoRedirect && <Loader inline />}

          <Button
            component="a"
            href={url}
            variant="contained"
            color="secondary"
            marginTop
            fullWidth
          >
            {buttonLabel}
          </Button>

          {onLogOut && (
            <Button
              onClick={onLogOut}
              variant="outlined"
              color="secondary"
              marginTop
              fullWidth
            >
              Log out
            </Button>
          )}
        </CardContent>
      </Card>
    </Modal>
  );
};

RedirectingModal.propTypes = {
  open: PropTypes.bool,
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.node,
  buttonLabel: PropTypes.string,
  delay: PropTypes.number,
  autoRedirect: PropTypes.bool,
  onLogOut: PropTypes.func,
};

RedirectingModal.defaultProps = {
  open: true,
  title: 'You’re being redirected to the new Bookkeeper Portal',
  text: 'Bookkeeper plans have moved to their own home. Hold tight while we take you there.',
  buttonLabel: 'Continue to the Bookkeeper Portal',
  delay: 2000,
  autoRedirect: true,
  onLogOut: undefined,
};

export default memo(RedirectingModal);
